<template>
  <div class="col-sm-12 m-0 p-0">
    <div class="table-responsive">
      <table class="table table-sm table-hover">
        <thead>
          <tr class="header-lvl-1">
            <th class="align-middle text-center sticky-col-1">
              {{
                detail.mekanisme_pembayaran === 'TERMIN' ? 'Termin' : 'Bulan'
              }}
            </th>
            <th class="align-middle text-center sticky-col-2">
              Tanggal Awal
            </th>
            <th class="align-middle text-center">
              Tanggal Akhir
            </th>
            <th class="align-middle text-center">
              Total Tagihan
            </th>
            <th class="align-middle text-center">
              Beban Vendor
            </th>
            <th class="align-middle text-center">
              Status
            </th>
            <th class="align-middle text-center">
              Status Tagihan
            </th>
            <th class="align-middle text-center">
              Tanggal Ditagih
            </th>
            <th class="align-middle text-center">
              Tanggal Bayar
            </th>
            <th class="align-middle text-center sticky-col-last">
              Aksi
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(item, index) in items" :key="item.id || item.no || index">
            <td class="sticky-col-1 text-center">
              {{ item.no }}
            </td>

            <td class="sticky-col-2 text-center">
              {{ dateFormat(item.tanggal_awal) }}
            </td>

            <td class="text-center">
              {{ dateFormat(item.tanggal_akhir) }}
            </td>

            <td class="text-right">
              <a
                href="javascript:void(0)"
                class="btn-link"
                @click="$emit('rincian-tagihan', item.no)"
              >
                Rp {{ formatRupiah(item.total_tagihan) }}
              </a>
            </td>

            <td class="text-right">
              <a
                href="javascript:void(0)"
                class="btn-link"
                @click="$emit('rincian-beban-vendor', item.no)"
              >
                Rp {{ formatRupiah(item.beban_sph_vendor) }}
              </a>
            </td>

            <td class="text-center">
              {{ item.status_draft || '-' }}
            </td>

            <td class="text-center">
              {{ item.status_tagihan || '-' }}
            </td>

            <td class="text-center">
              {{
                item.tanggal_ditagih !== null
                  ? dateFormat(item.tanggal_ditagih)
                  : '-'
              }}
            </td>

            <td class="text-center">
              <template v-if="item.tanggal_bayar === null">
                <a
                  href="javascript:void(0)"
                  class="btn-link"
                  @click="$emit('show-tanggal-bayar', item.no)"
                >
                  Set Tanggal Bayar
                </a>
              </template>

              <template v-else>
                {{ dateFormat(item.tanggal_bayar) }}
              </template>
            </td>

            <td class="sticky-col-last text-center">
              <div
                class="d-flex gap-5 align-items-center justify-content-center"
              >
                <button
                  v-if="authorizedUser"
                  class="btn btn-sm btn-outline-danger"
                  title="Hapus"
                  @click="$emit('remove', item.no)"
                >
                  <i class="fa fa-trash"></i>
                </button>

                <button
                  class="btn btn-sm btn-outline-primary"
                  title="Tambah Detail"
                  @click="$emit('add-detail', item)"
                >
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </td>
          </tr>

          <!-- TOTAL -->
          <tr class="total-row">
            <td class="sticky-col-1"></td>

            <td class="sticky-col-2"></td>

            <td class="font-weight-bold text-right">
              Total
            </td>

            <td class="text-right font-weight-bold">
              Rp {{ formatRupiah(totalTagihan) }}
            </td>

            <td class="text-right font-weight-bold">
              Rp {{ formatRupiah(totalBebanVendor) }}
            </td>

            <td></td>
            <td></td>
            <td></td>
            <td></td>

            <td class="sticky-col-last"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'TagihanTable',

  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },

    detail: {
      type: Object,
      default: () => ({}),
    },

    authorizedUser: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    totalTagihan() {
      return this.items.reduce(
        (total, item) => total + Number(item.total_tagihan || 0),
        0
      )
    },

    totalBebanVendor() {
      return this.items.reduce(
        (total, item) => total + Number(item.beban_sph_vendor || 0),
        0
      )
    },
  },

  methods: {
    dateFormat(date) {
      if (!date) return '-'

      return moment(date).format('DD/MM/YYYY')
    },

    formatRupiah(value) {
      const nominal = Number(value || 0)

      return nominal.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
  },
}
</script>

<style scoped>
.table-responsive {
  overflow: auto;
  max-height: 600px;
  position: relative;
}

.table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  font-size: 13px;
}

/* Border */
.table th,
.table td {
  border-top: 1px solid #e9ecef;
  border-left: 1px solid #e9ecef;
  padding: 8px 10px;
  background-color: #ffffff;
  white-space: nowrap;
}

/* Header Sticky */
.header-lvl-1 th {
  position: sticky;
  top: 0;
  background-color: #f8f9fa !important;
  z-index: 20;
  border-bottom: 1px solid #dee2e6;
  border-top: 1px solid #dee2e6;
}

/* Sticky Columns */
.sticky-col-1,
.sticky-col-2,
.sticky-col-last {
  position: sticky;
  z-index: 10;
  background-color: #ffffff !important;
}

.sticky-col-1 {
  left: 0;
  min-width: 80px;
}

.sticky-col-2 {
  left: 80px;
  min-width: 120px;
}

.sticky-col-last {
  right: 0;
  min-width: 130px;
  box-shadow: -4px 0 6px -4px rgba(0, 0, 0, 0.2);
}

/* Header sticky columns */
thead .sticky-col-1,
thead .sticky-col-2,
thead .sticky-col-last {
  z-index: 30;
  background-color: #f8f9fa !important;
}

/* Hover */
tr:hover td {
  background-color: #f8fafd !important;
}

/* Hover sticky */
tr:hover .sticky-col-last {
  box-shadow: -4px 0 6px -3px rgba(0, 0, 0, 0.3);
}

/* Total */
.total-row td {
  background-color: #f8f9fa !important;
  font-weight: 600;
  border-top: 2px solid #dee2e6;
}

.total-row .sticky-col-1,
.total-row .sticky-col-2,
.total-row .sticky-col-last {
  background-color: #f8f9fa !important;
}

/* Link */
.btn-link {
  cursor: pointer;
  text-decoration: none;
}

.btn-link:hover {
  text-decoration: underline;
}
</style>
